import { defineStore } from "pinia"
import { apiV1 } from "@/config/axios"
import { permissionsService } from "@/services/PermissionsService"

export const useHubsStore = defineStore("hubs", {
  state: () => ({
    hubs: [],
    activeHub: null
  }),
  getters: {
    accounts: (state) => {
      return state.activeHub ? state.activeHub.accounts : []
    },
    accountsByGroup: (state) => {
      return state.activeHub
        ? Object.values(
            state.activeHub.accounts.reduce((groups, account) => {
              if (!groups[account.current_campaign_type_name]) {
                groups[account.current_campaign_type_name] = {
                  name: account.current_campaign_type_name,
                  items: []
                }
              }
              groups[account.current_campaign_type_name].items.push(account)
              return groups
            }, {})
          )
        : []
    }
  },
  actions: {
    setHubs(hubs) {
      this.hubs = hubs
    },
    setActiveHub(hub) {
      permissionsService.setPermissions(hub.permissions)
      delete hub["permissions"]
      this.activeHub = hub
    },
    async changeHub(hub) {
      try {
        await apiV1.post("/users/hubs/active", { id: hub.id })

        const url = new URL(window.location)
        url.search = ""
        window.history.replaceState({}, "", url.pathname)

        location.reload()
      } catch {}
    },
    async changeHubManageDocuments(hub) {
      try {
        await apiV1.post("/users/hubs/active", { id: hub.id })
        location.reload()
      } catch {}
    },
    clearState() {
      this.hubs = []
      this.activeHub = null
    }
  }
})
